import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {catch404, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {enable301ResponseState} from "@pg-mono/response-state";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {redirectOrEnable404ResponseState} from "../../errors/actions/page_404_actions";
import {IArticleDetailArticle} from "./IArticleDetail";

export interface ITableOfContentsElement {
    text: string | null;
    id: string | null;
    elements: ITableOfContentsElement[];
}

const ARTICLE_DETAIL_PREFIX = "article_detail/fetch";
export const fetchArticleDetailTypes = createRequestActionTypes(ARTICLE_DETAIL_PREFIX);

export const fetchArticleDetail = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    dispatch({type: fetchArticleDetailTypes.start});
    const articleDetailApiLink = apiV2Link.article.detail(Scenario.ARTICLE_DETAIL, {articleId: ctx.match.params.articleId});

    return getRequest(ctx.meta, articleDetailApiLink)
        .then(async (article: IArticleDetailArticle) => {
            // validate slug
            if (ctx.match.params.articleSlug !== article.slug) {
                const link = rpAppLink.article.detail({articleId: article.id, articleSlug: article.slug});
                dispatch(enable301ResponseState(link));
                return false;
            }
            const {text: originalText} = article;

            const APMTtansaction = ctx.meta.apm?.transaction;
            const apmSpan = APMTtansaction?.startSpan("article", "parse", {childOf: APMTtansaction?.traceparent});

            // dynamic import to avoid htmlparser2 being bundled in the clientside article bundle
            const {extractHeadlines} = await import("../utils/extract_headlines");
            const {parseArticleText} = await import("../utils/parse_article_text");

            const {articleText, tableOfContents, articleHeaderIds} = extractHeadlines(originalText, "article");
            const modifiedText = parseArticleText(articleText, article.phrase_relations);

            apmSpan?.setOutcome("success");
            apmSpan?.end();

            dispatch({
                type: fetchArticleDetailTypes.success,
                result: {
                    ...article,
                    lead: article.lead?.replace(/[\n\r]/g, "\n"),
                    text: modifiedText
                        ?.replace(/&oacute;/g, "ó")
                        .replace(/&Oacute;/g, "Ó")
                        .replace(/[\n\r]/g, "\n"),
                    table_of_contents: tableOfContents,
                    article_header_ids: articleHeaderIds
                }
            });

            return article;
        })
        .catch(
            catch404(async () => {
                await dispatch(redirectOrEnable404ResponseState(ctx.route.pathname, ctx.meta));
            })
        );
};
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {catch404, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {enable301ResponseState} from "@pg-mono/response-state";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {redirectOrEnable404ResponseState} from "../../errors/actions/page_404_actions";
import {IArticleDetailArticle} from "./IArticleDetail";

export interface ITableOfContentsElement {
    text: string | null;
    id: string | null;
    elements: ITableOfContentsElement[];
}

const ARTICLE_DETAIL_PREFIX = "article_detail/fetch";
export const fetchArticleDetailTypes = createRequestActionTypes(ARTICLE_DETAIL_PREFIX);

export const fetchArticleDetail = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    dispatch({type: fetchArticleDetailTypes.start});
    const articleDetailApiLink = apiV2Link.article.detail(Scenario.ARTICLE_DETAIL, {articleId: ctx.match.params.articleId});

    return getRequest(ctx.meta, articleDetailApiLink)
        .then(async (article: IArticleDetailArticle) => {
            // validate slug
            if (ctx.match.params.articleSlug !== article.slug) {
                const link = rpAppLink.article.detail({articleId: article.id, articleSlug: article.slug});
                dispatch(enable301ResponseState(link));
                return false;
            }
            const {text: originalText} = article;

            const APMTtansaction = ctx.meta.apm?.transaction;
            const apmSpan = APMTtansaction?.startSpan("article", "parse", {childOf: APMTtansaction?.traceparent});

            // dynamic import to avoid htmlparser2 being bundled in the clientside article bundle
            const {extractHeadlines} = await import("../utils/extract_headlines");
            const {parseArticleText} = await import("../utils/parse_article_text");

            const {articleText, tableOfContents, articleHeaderIds} = extractHeadlines(originalText, "article");
            const modifiedText = parseArticleText(articleText, article.phrase_relations);

            apmSpan?.setOutcome("success");
            apmSpan?.end();

            dispatch({
                type: fetchArticleDetailTypes.success,
                result: {
                    ...article,
                    lead: article.lead?.replace(/[\n\r]/g, "\n"),
                    text: modifiedText
                        ?.replace(/&oacute;/g, "ó")
                        .replace(/&Oacute;/g, "Ó")
                        .replace(/[\n\r]/g, "\n"),
                    table_of_contents: tableOfContents,
                    article_header_ids: articleHeaderIds
                }
            });

            return article;
        })
        .catch(
            catch404(async () => {
                await dispatch(redirectOrEnable404ResponseState(ctx.route.pathname, ctx.meta));
            })
        );
};
